import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { API_Error } from "@/interfaces/api/response/api_response_types"
import { getRows } from "../requests/games"
import { API_Data_Get_Rows_Response } from "@/interfaces/api/rows/api_response_types"

type UseRowsParams = {
  locale: string
  profileId?: string | null
}

type RowsQueryKey = ['rows', string, string | null | undefined]

type RowsOptions = Omit<
  UseQueryOptions<API_Data_Get_Rows_Response, API_Error, API_Data_Get_Rows_Response, RowsQueryKey>,
  'queryKey' | 'queryFn'
>

export const useRows = ({ locale, profileId }: UseRowsParams, options?: RowsOptions) => 
  useQuery<API_Data_Get_Rows_Response, API_Error, API_Data_Get_Rows_Response, RowsQueryKey>({
    queryKey: ['rows', locale, profileId],
    retry: false,
    queryFn: () => getRows(locale, profileId),
    ...options
  })